module.exports = __webpack_public_path__ + "static/media/ironManHero.2e7688e3.png";